<template>
  <!--tableSet-->
  <div class="table-set"> 
		<sn-table
			:columns="columns"
			:data="tableData"
			:height="400"
			:rowKey="'key'"
			ref="table">
			<el-table-column slot="show"  label="表头名称(拖动可修改顺序)">
				<template slot-scope="scope"> 
					<div class="drag-template">
						<img src="../../../public/images/drag.png" class="drag handle">
						{{scope.row.name}}
					</div> 
				</template>
			</el-table-column>
			<el-table-column slot="show" label="是否显示">
				<template slot-scope="scope"> 
					<el-checkbox v-model="scope.row.show"></el-checkbox>
				</template>
			</el-table-column>
			<el-table-column slot="width"  label="列宽">
				<template slot-scope="scope">
					<el-input v-model="scope.row.width" oninput="value=value.replace(/^0|[^0-9]/g, '')"  placeholder="请输入内容" maxlength="3"></el-input>
				</template>
			</el-table-column>
			<el-table-column slot="fixed"  label="是否固定列头">
				<template slot-scope="scope">
					<el-checkbox v-model="scope.row.fixed"></el-checkbox>
				</template>
			</el-table-column>
		</sn-table>
		<div class="bottom" ref="bottom">
			<span class="bt submit" @click="deleteSelfConfigHandle">删除自定义配置</span> 
			<el-radio-group v-model="choseConfig" @change="choseConfigChange">
				<el-radio-button label="启用自定义配置" :disabled="!isHasSelfOption"></el-radio-button>
				<el-radio-button label="启用系统配置"></el-radio-button> 
			</el-radio-group>
			<span class="bt submit" @click="submitHandle">保存并启用自定义配置</span>
		</div>
  </div>
</template>
<script>
import Sortable from "sortablejs";
import { setSelfConfig, DeleteSelfConfig, ChoseSystemConfig, ChoseSelfConfig } from "@/service/api.js";
import commonConfig from "@/assets/javascript/config/commonConfig.js";
export default {
  name: "tableSet", 
  props: { 
		tableConfig: {
      type: Array,
      default: () => [],
    },
		isHasSelfOption: {
      type: Boolean,
      default: false,
    },
		isChoseSystem: {
      type: Boolean,
      default: false,
    },
		apiName: {
			type: String,
      default: "",
		}
	},
  data() {
    return {
			tableData: [],
			choseConfig: '启用系统配置',
			disabled: false,
			selfApiName:''
		};
  },
	watch:{
		isChoseSystem(){
			if(this.isChoseSystem) {
				this.choseConfig = "启用系统配置"
			} else {
				this.choseConfig = "启用自定义配置"
			}
		}
	},
	mounted(){
		this.$nextTick(()=>{
			this.rowDrop();
		});
		this.initApiName();
		
	},
  created(){
		this.tableData = JSON.parse(JSON.stringify(this.tableConfig));
		this.columns = [
			{ slot: 'name' },
			{ slot: 'show' }, 
			{ slot: 'width' },
			{ slot: 'fixed' }
		]
		this.initChoseConfig();
  }, 
  methods: {
    rowDrop() {
			this.$nextTick(()=>{
				const tbody = document.querySelector(".table-set .el-table__body-wrapper tbody");
				const _this = this;
				Sortable.create(tbody, {
					animation: 150,
					handle: '.handle',
					ghostClass: "blue-background-class",
					onEnd({ newIndex, oldIndex }) {
						let _tableConfig = JSON.parse(JSON.stringify(_this.tableData));
						const currRow = _tableConfig.splice(oldIndex, 1)[0];
						_tableConfig.splice(newIndex, 0, currRow);
						_tableConfig.forEach((item, index)=>{
							_this.$set(_this.tableData, index, item);
						}) 
					}
				});
			})
    }, 
		initApiName(){
			let api_name;
			if(this.apiName) {
				api_name = this.apiName;
			} else {
				// 根据路由查找本地配置（列表接口）
				let pageArr = this.$route.path.split('/');
				let page = pageArr[pageArr.length - 1];
				api_name = commonConfig.apiOption[page];
			}
			this.selfApiName = api_name;
		},
		initChoseConfig(){
			if(this.isChoseSystem) {
				this.choseConfig = "启用系统配置"
			} else {
				this.choseConfig = "启用自定义配置"
			}
		},
		choseConfigChange(val){
			if(val == "启用自定义配置") {
				this.ChoseSelfConfigQuery();
			} else {
				this.ChoseSystemConfigQuery();
			}
		},
		submitHandle(){
			let isAllHide = true;
			this.tableData.forEach((item, index)=>{
				item.order = index + 1;
				if(item.show){
					isAllHide = false;
				}
			})
			if(isAllHide) {
				this.$message.error("表格中至少显示一列");
				return;
			}
			let param = {
				api_name: this.selfApiName,
				config:{
					title:this.tableData
				}
			}
			this.submitQuery(param);
		},
		async submitQuery(param){
			let res = await setSelfConfig(param);
			if(res.code = 1) {
				this.$emit('submitTableSet')
			}
		},
		deleteSelfConfigHandle(){
			this.$confirm(`确定删除自定义配置吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				center: true
			}).then(() => {
				this.deleteSelfConfigQuery()
			}).catch(() => {
                  
      });
		},
		async deleteSelfConfigQuery(){
			let res = await DeleteSelfConfig({
				api_name: this.selfApiName,
			});
			if(res.code = 1) {
				this.$emit('submitTableSet')
			}
		},
		async ChoseSystemConfigQuery(){
			let res = await ChoseSystemConfig({
				api_name: this.selfApiName,
			});
			if(res.code = 1) {
				this.$emit('submitTableSet')
			}
		},
		async ChoseSelfConfigQuery(){
			let res = await ChoseSelfConfig({
				api_name: this.selfApiName,
			});
			if(res.code = 1) {
				this.$emit('submitTableSet')
			}
		},
  },
  watch: {},
};
</script>
<style lang="less">
.table-set {
	padding-bottom: 50px;
	.el-input__inner {
		height: 25px;
	}
	.drag {
		cursor:move;
		width: 30px;
	}
	.drag-template {
		display: flex;
		align-items: center;
	}
	.bottom {
		height: 50px;
		position: absolute;
		bottom: 0;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		width: 100% !important;
		box-shadow: 0px -1px 8px #e3e3ed;
		background: #f5f5fc;
		.bt {
			margin-top: 0 !important;
			padding:0 15px;
			margin-right: 15px !important;
		}
		.delete {
			background: #f56c6c;
			border-color: #f56c6c;
		}
	}
}
</style>